var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_393)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_170_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 34C20.6569 34 22 32.6569 22 31C22 29.3431 20.6569 28 19 28C17.3431 28 16 29.3431 16 31C16 32.6569 17.3431 34 19 34Z",
    fill: "#0AC0F8",
    stroke: "#0AC0F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 33C32.6569 33 34 31.6569 34 30C34 28.3431 32.6569 27 31 27C29.3431 27 28 28.3431 28 30C28 31.6569 29.3431 33 31 33Z",
    fill: "#0AC0F8",
    stroke: "#0AC0F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 16L22 19V23L34 20V16Z",
    fill: "#0AC0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 31V23M22 23V19L34 16V20M22 23L34 20M34 30V20",
    stroke: "#0AC0F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_170_393)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "url(#paint0_linear_170_393)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_170_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 34C20.6569 34 22 32.6569 22 31C22 29.3431 20.6569 28 19 28C17.3431 28 16 29.3431 16 31C16 32.6569 17.3431 34 19 34Z",
    fill: "#0AC0F8",
    stroke: "#0AC0F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 33C32.6569 33 34 31.6569 34 30C34 28.3431 32.6569 27 31 27C29.3431 27 28 28.3431 28 30C28 31.6569 29.3431 33 31 33Z",
    fill: "#0AC0F8",
    stroke: "#0AC0F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 16L22 19V23L34 20V16Z",
    fill: "#0AC0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 31V23M22 23V19L34 16V20M22 23L34 20M34 30V20",
    stroke: "#0AC0F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "url(#paint1_linear_170_393)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_170_393",
    x: 9,
    y: 13,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_170_393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_170_393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_170_393",
    x: -3,
    y: -3,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_170_393"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_170_393",
    x: 9,
    y: 13,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_170_393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_170_393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_393",
    x1: -0.842697,
    y1: 28.4161,
    x2: 51.0304,
    y2: 28.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#2A75E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796486,
    stopColor: "#2A75E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_393",
    x1: -0.842697,
    y1: 28.4161,
    x2: 51.0304,
    y2: 28.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#2A75E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796486,
    stopColor: "#2A75E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.8726612ba02095f2c2a2516ccc9ef6a3.svg";
export { ForwardRef as ReactComponent };